var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g3, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnna(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_39",
    "data-name": "Groupe 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 265.713,
    height: 750,
    viewBox: "0 0 265.713 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 265.713,
    height: 750,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 265.713,
    height: 749.998,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 92.683,
    height: 89.296,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 57,
    height: 26.833,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 102.979,
    height: 134.198,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_38",
    "data-name": "Groupe 38",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_66",
    "data-name": "Trac\\xE9 66",
    d: "M346.609,1344.049l13.181,85.426-20.55,59.618h45l18.267-22.614-7.66-40.63-2.011-84.62Z",
    transform: "translate(-186.94 -739.093)",
    fill: "#ffcaa6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_37",
    "data-name": "Groupe 37",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_36",
    "data-name": "Groupe 36",
    clipPath: "url(#clip-path-2)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_67",
    "data-name": "Trac\\xE9 67",
    d: "M394.01,1529.717,377.1,1568.7l-11.245-9.644-15.278,9.644,8.383-35.355L346.77,1568.7c.1-.3-11.99,12.156-8.363,24.263h45l18.267-22.614Z",
    transform: "translate(-186.107 -842.963)",
    fill: "#272d2f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_68",
    "data-name": "Trac\\xE9 68",
    d: "M401.949,1566.052s-18.571-7.072-30.643,0l-4.964,20.937s9.368-4.373,26.523,0Z",
    transform: "translate(-201.875 -861.253)",
    fill: "#272d2f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_69",
    "data-name": "Trac\\xE9 69",
    d: "M232.355,1330.488l-12.858,95.66,4.853,32.321-44.725,1.458,12.424-36.375-5.86-101.676Z",
    transform: "translate(-98.984 -728.43)",
    fill: "#ffcaa6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_70",
    "data-name": "Trac\\xE9 70",
    d: "M212.623,1562.5s8.964,20.085,10.806,26c5.507,17.7-6.045,22.522-6.045,22.522H172.052s-8.406-8.069-5.192-17.845c3.035-9.23,15.421-30.209,15.421-30.209l-8.689,25.44c14.168-6.621,28.4-7.471,42.707-1.431Z",
    transform: "translate(-91.546 -861.029)",
    fill: "#272d2f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_71",
    "data-name": "Trac\\xE9 71",
    d: "M222.9,1574.036s-9.266-4.126-16.785-4.126-17.051,4.1-17.051,4.1l-6.313,18.485c15.545-4.912,25.674-5.457,42.707-1.432Z",
    transform: "translate(-100.708 -865.111)",
    fill: "#272d2f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_72",
    "data-name": "Trac\\xE9 72",
    d: "M300.58,733.065s20.682,99.248-4.322,183.721l-2.788,87.13-127.281,15.4-3.378-95.149L152.691,727.9Z",
    transform: "translate(-84.141 -401.119)",
    fill: "#404a4c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_73",
    "data-name": "Trac\\xE9 73",
    d: "M50.446,440.244s29.178,13.419,34.242,7.217c4.11-5.032,8.328-10.956,12.1-16.579,7.267-10.83,12.877-20.528,12.877-20.528l4.589-84.539-15.433.775c-4.222,3.1-18.612,37.649-30.611,67.852-9.657,24.307-17.766,45.8-17.766,45.8",
    transform: "translate(-27.799 -179.544)",
    fill: "#3d3d3d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_74",
    "data-name": "Trac\\xE9 74",
    d: "M50.446,524.481S79.624,537.9,84.688,531.7c4.11-5.032,8.328-10.956,12.1-16.579l-25.623-36.44H68.212c-9.657,24.307-17.766,45.8-17.766,45.8",
    transform: "translate(-27.799 -263.781)",
    fill: "#282828"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_75",
    "data-name": "Trac\\xE9 75",
    d: "M180.632,509.492s23.161,11.95,58.061,12.321A120.123,120.123,0,0,0,273.315,517c15.608-4.518,25.193-10.584,25.193-10.584L274.542,308.7l-7.128-.56L235.5,305.63l-25.082,2.6-12.568,1.3L181.769,496.271Z",
    transform: "translate(-99.538 -168.421)",
    fill: "#64c5b1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_29",
    "data-name": "Groupe 29",
    transform: "translate(81.094 264.103)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_28",
    "data-name": "Groupe 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_27",
    "data-name": "Groupe 27",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_76",
    "data-name": "Trac\\xE9 76",
    d: "M180.632,665.248s23.161,11.95,58.061,12.321a120.123,120.123,0,0,0,34.622-4.817L212.483,588.28l-30.714,63.747Z",
    transform: "translate(-180.632 -588.28)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_32",
    "data-name": "Groupe 32",
    transform: "translate(110.876 137.209)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_31",
    "data-name": "Groupe 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_30",
    "data-name": "Groupe 30",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_77",
    "data-name": "Trac\\xE9 77",
    d: "M246.971,308.231l3.354,1.84c8.565,12.178,28.9,19.743,49.756,22.391l3.891-24.325-31.918-2.507Z",
    transform: "translate(-246.971 -305.63)"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_78",
    "data-name": "Trac\\xE9 78",
    d: "M255.9,14.477S248.926.156,232.313.007s-38.84,9.146-46.451,22.858S179.619,56.57,173.37,66.7s-4.232,20.158,0,26.585,11.027,9.841,10.783,15.549-7.659,11.832-6.516,14.232,9.832-.743,12.232-3.315a22.272,22.272,0,0,1-3.316,5.258c-2.229,2.629-.857,4.8.8,5.6s6.8-.057,9.2-5.258c0,0,1.715,7.144,4.915,7.144s3.315-9.316,3.315-9.316.229,11.66,8.973,12.174,37.818-.366,39.831-.857,1.682-3.541,2.653-7.542c0,0,3.439,8.254,10.214,7.156,2.39-.388,1.086-3.631,1.2-6.395,0,0,4.515,6.1,10.631,4.784s-1.943-5.148-3.087-8.52c0,0,6.22.62,8.116-1.576,2.444-2.829-7.055-7.734-6.344-15.457s.46-10.971,5.376-15.772,8.982-12.447,5.937-21.8a246.832,246.832,0,0,1-8.6-33.537c-2.286-12.4-6.249-18.176-11.233-21.024-3.6-2.058-9.109-2.551-12.556-.333",
    transform: "translate(-93.351 -0.005)",
    fill: "#db5223"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_79",
    "data-name": "Trac\\xE9 79",
    d: "M426.042,327.544c18.822,13.488,61.5,108.41,61.5,108.41L459.437,467l-50.85-76.68Z",
    transform: "translate(-225.155 -180.497)",
    fill: "#3d3d3d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_80",
    "data-name": "Trac\\xE9 80",
    d: "M259.377,271.337l19.512,12.16,21.5-12.16c-1.661-2.753-2.606-6.792-3.125-10.952-.161-1.285-.282-2.583-.372-3.859a103.392,103.392,0,0,1-.018-13.128l-34.063.623a81.265,81.265,0,0,1,.372,12.5c-.045.891-.112,1.8-.2,2.7-.443,4.513-1.469,9.058-3.609,12.111",
    transform: "translate(-142.931 -134.128)",
    fill: "#f48267"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_81",
    "data-name": "Trac\\xE9 81",
    d: "M254.448,288.1c.976,4.63,11,13.033,21.719,13.033s27.127-7.163,24.285-13.687-2.078-13.288-2.78-14.054-3.5-.757-3.5-.757c.089,1.276.211,2.574.372,3.86,0,0-5.807,3.2-17.059,3.434s-17.224-4.594-17.224-4.594c.089-.9.157-1.809.2-2.7,0,0-2.91.273-2.745,2.194.461,5.261-3.515,12.133-3.273,13.27",
    transform: "translate(-140.209 -150.242)",
    fill: "#64c5b1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_82",
    "data-name": "Trac\\xE9 82",
    d: "M72.267,689.534S97.044,702.3,154.93,701.967c0,0-.43-157.6.426-213.17.331-21.585-.045-50.409-.479-79.287-.681-45.462-1.509-91.058.053-108.757,0,0-3.814.681-8.905,1.67l0,0c-7.316,1.419-17.264,3.474-22.3,5.046a72.43,72.43,0,0,0-12.872,5.306l8.3,44.24s-8.458,19.771-8.3,32.222,6.335,45.905,3.734,57.819S74.38,624.394,72.267,689.534",
    transform: "translate(-39.823 -165.734)",
    fill: "#3d3d3d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M355.655,302.14c1.549,17.52,3.662,64.078,5.274,110.422,1.048,30.195,1.89,60.3,2.229,82.224.855,55.571,3.761,209.669,3.761,209.669,57.886.336,74.438-13.445,74.438-13.445-2.113-65.139-5.838-163.285-36.821-231.222-5.059-11.1-3.362-61.006-3.21-73.462s-9.174-30.418-9.174-30.418l4.719-42.364s-3.259-2.669-20.291-7.455c-3.354-.94-7.271-1.746-10.8-2.382h0c-5.538-1-10.123-1.567-10.123-1.567",
    transform: "translate(-195.986 -166.498)",
    fill: "#3d3d3d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84",
    "data-name": "Trac\\xE9 84",
    d: "M355.655,302.14c1.549,11.708,3.662,42.822,5.274,73.793l20.51-47.038-20.393-5.027,18.373-2.75-13.635-17.931h0c-5.538-.668-10.123-1.047-10.123-1.047",
    transform: "translate(-195.986 -166.498)",
    fill: "#282828"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85",
    "data-name": "Trac\\xE9 85",
    d: "M226.045,380.033c-.681-33.14-1.509-66.378.054-79.279,0,0-3.815.5-8.905,1.217l0,0-13.75,19.481,19.288,3.649-21.311,4.834Z",
    transform: "translate(-110.992 -165.734)",
    fill: "#282828"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_86",
    "data-name": "Trac\\xE9 86",
    d: "M368.212,162.038s1-6.259,5.922-7.395,9.035,5.338,7.777,11.989-9.6,15.374-12.574,16.843a25.829,25.829,0,0,1-5.8,2.02l-6.607-10.153Z",
    transform: "translate(-196.687 -85.147)",
    fill: "#f48267"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_87",
    "data-name": "Trac\\xE9 87",
    d: "M206.509,162.038s-1-6.259-5.922-7.395-9.035,5.338-7.777,11.989,9.6,15.374,12.574,16.843a25.837,25.837,0,0,0,5.8,2.02l6.607-10.153Z",
    transform: "translate(-106.123 -85.147)",
    fill: "#f48267"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_88",
    "data-name": "Trac\\xE9 88",
    d: "M223.615,116.321c1.307,7.267,3.6,19.449,5.274,25.883,2.919,11.2,23.205,20.931,30.293,20.931s27.369-9.729,30.293-20.931c1.675-6.434,3.962-18.612,5.274-25.878,0,0-2.811-8.077-2.18-14.041-.108.69-1.034,6.241-3.094,6.985-2.2.792-1.706-4.477-1.706-4.477s-1.539,4.359-3.065,3.025,7.856-16.138-5.406-36.259c0,0-9.987,34.461-30.013,35.742-3.734.237,0-3.849,1.663-11.623,0,0-2.915,9.944-11.278,11.305-4.1.667-1.208-4.862-.157-8.811,0,0-4.661,9.42-12.335,11.144Z",
    transform: "translate(-123.225 -39.434)",
    fill: "#ffcaa6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_89",
    "data-name": "Trac\\xE9 89",
    d: "M0,376.926a47.529,47.529,0,0,1,14.456-6.478l2.115,14.1Z",
    transform: "translate(0 -204.14)",
    fill: "#282828"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_90",
    "data-name": "Trac\\xE9 90",
    d: "M39.085,256.1c-1.924-.276,2.681-50.226-2.194-50.226-5.242,0-6.141,41.9-6.141,41.9S13.5,264.487,12.642,269.361,14,281.007,18.925,282.374l1.638,8.556,13.482-6.824Z",
    transform: "translate(-6.868 -113.453)",
    fill: "#ffcaa6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_91",
    "data-name": "Trac\\xE9 91",
    d: "M23.612,283.585c-1.671-2.581-8.321-.333-12.749,2.879s-8.808,9.973-8.7,13.272,5.94,13.713,8.825,13.9,12.17-4.907,15.021-7.06,1.865-16.407-2.394-22.989",
    transform: "translate(-1.189 -155.654)",
    fill: "#ffcaa6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_92",
    "data-name": "Trac\\xE9 92",
    d: "M47.547,341.8l-.4-8.378S57.66,320.1,56.686,315.049s-23.172-9.492-23.762-7.144,12.429,11.313,12.429,11.313-7.067,3.208-9.139,9.666S38.948,341.8,38.948,341.8Z",
    transform: "translate(-18.132 -169.319)",
    fill: "#ffcaa6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_93",
    "data-name": "Trac\\xE9 93",
    d: "M16.478,317.635c1.063,1.11,1.718,1.371,2.08,1.393,2.627.182,11.759-4.7,14.783-6.987a3.056,3.056,0,0,0,.9-1.511c-1.715-1.217-4.3-3.121-6.54-5.022l2,6.432a.36.36,0,0,1-.233.451.366.366,0,0,1-.107.014.359.359,0,0,1-.343-.251l-2.345-7.542c-2.141-1.919-3.73-3.726-3.483-4.707a.9.9,0,0,1,.476-.566,3.473,3.473,0,0,1,1.267-.315l-1.757-5.659a.359.359,0,0,1,.236-.451.363.363,0,0,1,.447.237l1.815,5.835a39.9,39.9,0,0,1,8.716,1.221,38.238,38.238,0,0,0-.92-4.432.357.357,0,0,1,.251-.437.353.353,0,0,1,.44.251,39.531,39.531,0,0,1,.977,4.8c1.442.358,2.86.763,4.152,1.2a.358.358,0,0,1-.226.68c-1.26-.422-2.552-.795-3.826-1.12-.247-.061-.5-.122-.744-.179a40.885,40.885,0,0,0-8.6-1.263c-.272,0-.523.007-.744.025a3,3,0,0,0-1.142.243c-.089.05-.122.093-.125.108-.14.551.823,1.722,2.362,3.168.326.3.673.623,1.046.949,2.033,1.783,4.686,3.833,7.148,5.6.211.15.419.3.623.444q.564.4,1.106.773a.357.357,0,0,1,.154.325.362.362,0,0,1-.211.3c-.068.029-6.944,3.211-8.945,9.446a10.938,10.938,0,0,0-.5,3.626.359.359,0,0,1-.347.369h-.011a.359.359,0,0,1-.358-.348,11.614,11.614,0,0,1,.533-3.866,14.92,14.92,0,0,1,3.894-6.057c-3.873,2.269-9.343,4.947-11.687,4.947-.061,0-.122,0-.176-.007a4.427,4.427,0,0,1-2.552-1.61.358.358,0,1,1,.516-.5m18.782-6.382c-.129-.089-.268-.186-.419-.294a5.39,5.39,0,0,1-.3.695c.279-.161.527-.3.723-.4",
    transform: "translate(-8.741 -161.406)",
    fill: "#f48267"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_94",
    "data-name": "Trac\\xE9 94",
    d: "M14.413,308.627a.357.357,0,0,1,.466.2l6.3,15.607a.357.357,0,0,1-.2.466.353.353,0,0,1-.134.026.359.359,0,0,1-.332-.224l-6.3-15.607a.359.359,0,0,1,.2-.466",
    transform: "translate(-7.819 -170.058)",
    fill: "#f48267"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_95",
    "data-name": "Trac\\xE9 95",
    d: "M29.065,365.4S58,466.614,56.89,469.275c-3.658,4.032-15.607,20.511-30.446,13.353C8.982,474.206,0,374.143,0,374.143A38.771,38.771,0,0,0,29.065,365.4",
    transform: "translate(0 -201.356)",
    fill: "#3d3d3d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_96",
    "data-name": "Trac\\xE9 96",
    d: "M431.643,360.529l-102.463,2.247-24.674,133.9,96.765-2.015Z",
    transform: "translate(-167.8 -198.674)",
    fill: "#f6f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_35",
    "data-name": "Groupe 35",
    transform: "translate(136.706 163.8)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_34",
    "data-name": "Groupe 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_33",
    "data-name": "Groupe 33",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_97",
    "data-name": "Trac\\xE9 97",
    d: "M401.271,497.043l6.214-27.444-64.5-104.741-13.809.3-24.674,133.9Z",
    transform: "translate(-304.506 -364.859)"
  }))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_98",
    "data-name": "Trac\\xE9 98",
    d: "M390.224,606.45V595.533l8.277-3.358Z",
    transform: "translate(-215.036 -326.324)",
    fill: "#aeedf4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_99",
    "data-name": "Trac\\xE9 99",
    d: "M343.453,540.144s-3.409-6.35-6.1-8.857-10.477,1.041-29.594.012c-4.909-.264-1.657,6.761,3.724,7.335-3.344.947-2.761,5.758-.59,6.723,0,0-2.507-.179-3.045,2.866s2.642,3.515,2.642,3.515c-1.612.089-4.97,4.41.37,6.541-2.161.063-3.236,3.734-.848,4.6,3.539,1.282,26.709,3.845,35.375,3.728L372.5,551.268Z",
    transform: "translate(-168.265 -292.266)",
    fill: "#ffcaa6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_100",
    "data-name": "Trac\\xE9 100",
    d: "M322.942,543.586h.035l17.1-1.343a.438.438,0,0,0,.189-.059l4.03-2.328a.448.448,0,0,0-.448-.775l-3.942,2.277-17,1.335a.448.448,0,0,0,.035.894",
    transform: "translate(-177.713 -297.032)",
    fill: "#f48267"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_101",
    "data-name": "Trac\\xE9 101",
    d: "M477.423,559.624c-4.128-8.964-87.2-7.579-87.2-7.579s7.38,14.416,0,32.248c0,0,63.872,11.584,76.486,8.688s18.092-17.333,10.713-33.357",
    transform: "translate(-215.036 -304.167)",
    fill: "#3d3d3d"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_102",
    "data-name": "Trac\\xE9 102",
    d: "M344.217,128.624a13.533,13.533,0,0,0-10.868-6.432c-7.4-.216-11.682,4.67-10.882,7.079.447,1.347,4.609-5.234,10.95-5.012,7.2.252,10.8,4.365,10.8,4.365",
    transform: "translate(-177.644 -67.332)",
    fill: "#e85d24"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_103",
    "data-name": "Trac\\xE9 103",
    d: "M326.364,160.492a.446.446,0,0,0,.378-.206,8.364,8.364,0,0,1,6-3.5,10.159,10.159,0,0,1,6.8,2.227.448.448,0,0,0,.594-.67,10.868,10.868,0,0,0-7.454-2.451,9.118,9.118,0,0,0-6.7,3.91.447.447,0,0,0,.377.688",
    transform: "translate(-179.599 -85.895)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_104",
    "data-name": "Trac\\xE9 104",
    d: "M331.746,168.621a2.951,2.951,0,1,0,2.945-3.129,3.041,3.041,0,0,0-2.945,3.129",
    transform: "translate(-182.811 -91.197)",
    fill: "#3f1d0f"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_105",
    "data-name": "Trac\\xE9 105",
    d: "M338.389,168.866a.895.895,0,1,0,.443-1.226.923.923,0,0,0-.443,1.226",
    transform: "translate(-186.426 -92.343)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_106",
    "data-name": "Trac\\xE9 106",
    d: "M234.637,128.624a13.533,13.533,0,0,1,10.869-6.432c7.4-.216,11.682,4.67,10.882,7.079-.447,1.347-4.609-5.234-10.95-5.012-7.2.252-10.8,4.365-10.8,4.365",
    transform: "translate(-129.298 -67.332)",
    fill: "#e85d24"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_107",
    "data-name": "Trac\\xE9 107",
    d: "M261.668,160.493a.448.448,0,0,0,.377-.688,9.118,9.118,0,0,0-6.7-3.91,10.891,10.891,0,0,0-7.454,2.451.448.448,0,0,0,.594.67,10.174,10.174,0,0,1,6.8-2.227,8.322,8.322,0,0,1,6,3.5.447.447,0,0,0,.378.207",
    transform: "translate(-136.522 -85.896)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_108",
    "data-name": "Trac\\xE9 108",
    d: "M266.692,168.621a2.951,2.951,0,1,1-2.945-3.129,3.041,3.041,0,0,1,2.945,3.129",
    transform: "translate(-143.716 -91.197)",
    fill: "#3f1d0f"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_109",
    "data-name": "Trac\\xE9 109",
    d: "M267.444,168.866a.895.895,0,1,0,.443-1.226.923.923,0,0,0-.443,1.226",
    transform: "translate(-147.331 -92.343)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_110",
    "data-name": "Trac\\xE9 110",
    d: "M243.069,143.953a15.944,15.944,0,0,1,15.917,15.48h4.273a15.928,15.928,0,1,1,0,.9h-4.273a15.926,15.926,0,1,1-15.917-16.376m36.107,30.961a15.033,15.033,0,1,0-15.021-15.48h.834a.448.448,0,1,1,0,.9h-.834a15.047,15.047,0,0,0,15.021,14.585m-36.107,0a15.048,15.048,0,0,0,15.022-14.585h-.834a.448.448,0,1,1,0-.9h.834a15.031,15.031,0,1,0-15.022,15.48",
    transform: "translate(-125.168 -79.328)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_111",
    "data-name": "Trac\\xE9 111",
    d: "M300.119,217.789H286.284s4.953,4.242,6.917,4.8,6.917-4.8,6.917-4.8",
    transform: "translate(-157.759 -120.016)",
    fill: "#f48267"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_112",
    "data-name": "Trac\\xE9 112",
    d: "M276.71,223.524a34.1,34.1,0,0,0,.846,6.237,21.86,21.86,0,0,0,3.139,7.584,9.734,9.734,0,0,0,7.746,4.468,9.488,9.488,0,0,0,8.095-3.828,22.266,22.266,0,0,0,3.738-7.705,34.268,34.268,0,0,0,1.146-5.749,34.219,34.219,0,0,1-12.979,2.145c-7.522-.179-11.73-3.152-11.73-3.152",
    transform: "translate(-152.483 -123.176)",
    fill: "#89211b"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_113",
    "data-name": "Trac\\xE9 113",
    d: "M276.71,223.524a34.1,34.1,0,0,0,.846,6.237c9.022,3.018,18.567,1.464,22.717.519a34.268,34.268,0,0,0,1.146-5.749,34.219,34.219,0,0,1-12.979,2.145c-7.522-.179-11.73-3.152-11.73-3.152",
    transform: "translate(-152.483 -123.176)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_114",
    "data-name": "Trac\\xE9 114",
    d: "M285.586,252.305a9.736,9.736,0,0,0,7.746,4.468,9.488,9.488,0,0,0,8.095-3.828,17.784,17.784,0,0,0-9.617-2.261,14.057,14.057,0,0,0-6.223,1.621",
    transform: "translate(-157.374 -138.136)",
    fill: "#ea8071"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnna);
export default __webpack_public_path__ + "static/media/anna.2c22ecaeaa70911aaf97bdf81301b046.svg";
export { ForwardRef as ReactComponent };